export const FETCH_REACTIONS = 'FETCH_REACTIONS';
export const CREATE_REACTION = 'CREATE_REACTION';
export const REMOVE_REACTION = 'REMOVE_REACTION';
export const TOGGLE_REACTION = 'TOGGLE_REACTION';
